import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { PremiumUserResponse } from '../contracts/premiumUserResponse';

export default mutatorAction('setPremiumUserState', function setPremiumUserState(
    response: PremiumUserResponse
) {
    store.userInfo.firstName = response.firstName;
    store.userInfo.lastName = response.lastName;
    store.userInfo.emailAddress = response.emailAddress;
    store.userInfo.prosumerEmailAddress = response.prosumerEmailAddress;
    store.userInfo.isProsumerConsumerMailbox = response.isProsumerConsumerMailbox;
    store.userInfo.safeLinksEnabled = response.safeLinksEnabled;
});
